import { NgModule } from '@angular/core';
import { QPCompanySelectComponent } from '@widgets/site-common/qp-company-select/qp-company-select.component';
import { QPSelectCardComponent } from '@widgets/site-common/qp-company-select/qp-select-card/qp-select-card.component';
import { UiCommonModule } from '@widgets/ui-common/ui.common.module';

@NgModule({
  declarations: [QPCompanySelectComponent, QPSelectCardComponent],
  imports: [UiCommonModule],
  exports: [QPCompanySelectComponent]
})
export class QPCompanySelectModule {}
